export default {"src":"/_next/static/media/ProductDetail.2747096e.svg","height":24,"width":22,"blurWidth":0,"blurHeight":0};